import { render, staticRenderFns } from "./TakeAwayReminderDialog.vue?vue&type=template&id=199a7b13&"
import script from "./TakeAwayReminderDialog.vue?vue&type=script&lang=js&"
export * from "./TakeAwayReminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./TakeAwayReminderDialog.vue?vue&type=style&index=0&id=199a7b13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports